/** Settings → Operations → "RFQ requests pilot" (Files → RFQs "Requests" view). */
import React from 'react';
import { rfqRequestsFlag } from '../../utils/rfqRequestsAccess';
import PilotFlagCard from './PilotFlagCard';

const RfqRequestsPilotCard: React.FC = () => (
  <PilotFlagCard
    flag={rfqRequestsFlag}
    title="RFQ requests pilot"
    ariaLabel="RFQ requests pilot"
    description="Files → RFQs becomes the place to request timber quotes per structure: a coverage strip (what was requested at which version), a request wizard that batches structures into one Concept or Production RFQ per supplier (one email, one combined list, one quote upload), and a list of request rounds. Everyone else keeps today's RFQ file list and the Suppliers-tab publish flow."
    enableAllConfirm="Enable the Requests view for every staff account? The Suppliers tab stays for approvals; new quote requests move to Files → RFQs."
    gaNotice="Phase 2 (approvals in the round card, then hiding the Suppliers tab) can now hang off this flag."
  />
);

export default RfqRequestsPilotCard;
